import { Link } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";

const faqs = [
  {
    id: "OneA",
    question: "Why should I choose Infinitive Host?",
    answer:
      "Because we focus on delivering high performance, unbeatable security, budget-friendliness, and reliable technical support without unwanted challenges."
  },
  {
    id: "TwoA",
    question: "Can I upgrade my web hosting plan later?",
    answer:
      "Absolutely. You can easily upgrade your web hosting plan anytime as your website or business scales."
  },
  {
    id: "ThreeA",
    question: "Is Infinitive Host an Indian company?",
    answer:
      "Yes. Infinitive Host is an India-based web hosting provider serving clients worldwide with powerful infrastructure and 24/7 expert support."
  },
  {
    id: "FourA",
    question: "What features are included with your web hosting plans?",
    answer:
      "Our hosting plans include a free SSL certificate, high-speed servers, email accounts, automatic backups, strong security, and a user-friendly control panel. Learn more",
    linkText: "about us",
    linkUrl: `${import.meta.env.VITE_FRONTEND_URL}/about-us`
  },
  {
    id: "FiveA",
    question: "How reliable is Infinitive Host’s technical support?",
    answer:
      "Our expert technical support is available 24/7 with instant responses and real human assistance, no bots, no delays."
  },
  {
    id: "SixA",
    question: "Can I migrate my website to Infinitive Host?",
    answer:
      "Yes, We provide hassle-free website migration with 99.9% uptime assurance."
  },
  {
    id: "SevenA",
    question: "What types of web hosting services do you offer?",
    answer:
      "We offer shared hosting, VPS hosting, cloud hosting, dedicated servers, streaming servers, and GPU hosting solutions."
  },
  {
    id: "EightA",
    question: "Is Infinitive Host suitable for scaling business websites?",
    answer:
      "Yes, Our hosting solutions are engineered for business websites, eCommerce platforms, and high-traffic applications."
  },
  {
    id: "NineA",
    question: "Are Infinitive Host’s hosting services beginner-friendly?",
    answer:
      "Yes, Our services are designed for non-technical users with quick setup, easy management, and complete support."
  },
  {
    id: "TenA",
    question: "What security measures do you offer?",
    answer:
      "We provide SSL certificates, firewall protection, malware scanning, automatic backups, and server-level security."
  },
  {
    id: "ElevenA",
    question: "How does Infinitive Host support small business growth?",
    answerParts :[
      "We offer fast, stable, and budget-friendly hosting with 24/7 expert ",
      "support",
      " so small businesses can focus on growth."
    ],
    linkUrl: `${import.meta.env.VITE_FRONTEND_URL}/contact-us`
  },
  {
    id: "TwelveA",
    question: "Why does my business need a website?",
    answer:
      "A website builds credibility, attracts customers continuously, and helps your business expand beyond local reach."
  },
  {
    id: "ThirteenA",
    question: "Why should I transfer my domain or hosting to Infinitive Host?",
    answer:
      "For improved performance, enhanced security, 24/7 expert support, and smooth, stress-free migration."
  },
  {
    id: "FourteenA",
    question: "Does a dedicated server need a GPU?",
    answer:
      "Not always. However, GPU dedicated servers are essential for AI, 3D rendering, and high-quality video processing."
  },
  {
    id: "FifteenA",
    question: "Can I upgrade from shared hosting to cloud hosting?",
    answer:
      "Yes, You can easily upgrade from shared hosting to cloud hosting anytime, with expert guidance from our team."
  },
  {
    id: "SixteenA",
    question: "What type of cloud backup options do you offer?",
    answer:
      "We provide automated backups stored across multiple locations to ensure data safety during emergencies or data loss."
  },
  {
    id: "SeventeenA",
    question: "Can we customize network redundancy based on business needs?",
    answer:
      "Yes, We offer customized network redundancy solutions to ensure high performance, speed, and scalability."
  },
  {
    id: "EighteenA",
    question: "Do I get a cPanel license with cPanel Linux Hosting?",
    answer:
      "Yes, The cPanel license is included at no extra cost, giving full control over websites, emails, and databases."
  },
  {
    id: "NineteenA",
    question: "Which operating systems are available in Linux hosting?",
    answer:
      "We provide Ubuntu, Debian, CentOS, and Fedora for compatibility, speed, and stability."
  },
  {
    id: "TwentyA",
    question: "Can I scale my Windows VPS hosting plan?",
    answer:
      "Yes, You can easily upgrade or downgrade CPU, RAM, and storage as your requirements grow."
  },
  {
    id: "TwentyOneA",
    question: "Can I install custom software on my Windows VPS?",
    answer:
      "Yes, You get full administrative access to install and configure any required software or applications."
  },
  {
    id: "TwentyTwoA",
    question: "What virtualization technology do you use for VPS?",
    answer:
      "We use OpenVZ and KVM virtualization to ensure maximum performance and flexibility."
  },
  {
    id: "TwentyThreeA",
    question: "What techniques do you use to optimize VPS speed?",
    answer:
      "We use NGINX, Memcached, Varnish, LiteSpeed, and other optimizations based on client requirements."
  },
  {
    id: "TwentyFourA",
    question: "Where are Infinitive Host servers located?",
    answer:
      "Our servers are located in Europe, the United States, and Asia to ensure global availability."
  },
  {
    id: "TwentyFiveA",
    question: "How many IPs are included with unmanaged Linux VPS?",
    answer:
      "Each unmanaged Linux VPS plan includes one free dedicated IP address."
  },
  {
    id: "TwentySixA",
    question: "Which control panels are available with dedicated servers?",
    answer:
      "We offer cPanel, Plesk, CWP, and Virtualmin-choose the one you are most comfortable with."
  },
  {
    id: "TwentySevenA",
    question: "Do video streaming servers support multiple formats?",
    answer:
      "Yes, Our streaming servers support multiple video formats for smooth playback across all devices."
  },
  {
    id: "TwentyEightA",
    question: "Are there resources for learning GPU computing?",
    answer:
      "Yes, NVIDIA and other platforms provide free GPU computing resources for students and learners."
  },
  {
    id: "TwentyNineA",
    question: "Can I rent a GPU dedicated server for short-term?",
    answer:
      "No, We currently do not offer GPU dedicated servers on a short-term or rental basis."
  },
  {
    id: "ThirtyA",
    question: "What should I consider when choosing a GPU server provider?",
    answer:
      "Look for high-speed connectivity, low latency, and sufficient bandwidth for data-intensive workloads."
  }
];


function FAQs() {
  return (
    <>
      <Helmet>
        <title>FAQs | Web Hosting & Server Support – Infinitive Host</title>
        <meta name="description" content="Have questions about web hosting? Explore our FAQs to learn about features, billing, migration, uptime, security, and customer support." />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/frequently-asked-questions`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/frequently-asked-questions`} />
        <meta property="og:title" content="Infinitive Host FAQs | Web Hosting & Server Help Centre" />
        <meta property="og:description" content="Get quick answers to all your hosting questions including server setup, pricing, uptime, security, and technical support." />
      </Helmet>

      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">FAQ</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Frequently Asked Questions
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Check out our FAQs to find real-world solutions about uptime, security, SSL, hosting features, and everything you wish to know about.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-100 pb-100">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div
              className="accordion border-0 vps-hosting-accordion"
              id="accordionFaq2"
            >
              {faqs.map((faq, index) => (
                <div
                  key={faq.id}
                  className="accordion-item border rounded-3 mb-4 sal-animate"
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-delay="300"
                  data-sal-easing="ease-in-out-sine"
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button bg-transparent ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#faq-collapse${faq.id}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`faq-collapse${faq.id}`}
                    >
                      <span className="fs-16 fw-bold faq-heading">
                        {faq.question}
                      </span>
                    </button>
                  </h2>

                  <div
                    id={`faq-collapse${faq.id}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                    data-bs-parent="#accordionFaq2"
                  >
                    <div className="accordion-body pt-0">
                      {faq.answerParts ? (
                        <>
                          {faq.answerParts[0]}
                          <Link
                            to={faq.linkUrl}
                            className="text-primary fw-semibold"
                          >
                            {faq.answerParts[1]}
                          </Link>
                          {faq.answerParts[2]}
                        </>
                      ) : (
                        <>
                          {faq.answer}
                          {faq.linkUrl && faq.linkText && (
                            <>
                              {" "}
                              <Link
                                to={faq.linkUrl}
                                className="text-primary fw-semibold"
                              >
                                {faq.linkText}
                              </Link>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQs;
